










import { Component, Prop, Vue } from 'vue-property-decorator';
import AlpacaBtn from '@/components/AlpacaBtn.vue';
import SelectRecyclePopup from '@/components/SelectRecyclePopup.vue';

@Component({
  components: {
    AlpacaBtn,
    SelectRecyclePopup,
  },
})
export default class Recycle extends Vue {
  public showSelectPopup: boolean = false;

  public togglePopup(tab: string) {
    this.showSelectPopup = !this.showSelectPopup;
  }
}
